import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FieldContainer from '../components/FieldContainer';
import { isFieldLocked } from '../components/utils';
import cx from 'classnames';
import Slider, { Handle } from 'rc-slider';
import 'rc-slider/assets/index.css';
import toNumber from 'lodash/toNumber';

// The value bubble lives in the handle, above it: it follows the handle while dragging
// (rc-slider's tooltip stays where the drag started). The marks stay readable under the handle
const VALUE_BUBBLE_ROOM = 26; // px kept above the rail so the bubble does not cover the label
// Nothing chosen yet: rc-slider reads 0, below the minimum, so the bubble shows the minimum instead
const renderHandleWithValue = (min) => {
  const renderHandle = ({ index, dragging, ...props }) => (
    <Handle {...props} key={index}>
      <span className={cx('af-slider-field__value', dragging && 'is-dragging')}>{Math.max(min, props.value)}</span>
    </Handle>
  );
  return renderHandle;
};

// 0 is a real answer (a slider whose minimum is 0 or below): only a missing value counts as empty
const hasValue = (value) => value !== undefined && value !== null && value !== '';

class SliderField extends PureComponent {
  render() {
    const { disabled, locked, marks, max, min, name, onChange, showDots, showTooltip, step, styles, vertical, value } = this.props;
    const { trackStyle = {}, railStyle = {}, handleStyle = {}, dotStyle = {}, activeDotStyle = {} } = styles;
    const isLocked = isFieldLocked(name, locked);
    return (
      <FieldContainer {...this.props} vertical={vertical}>
        <div style={{ marginTop: showTooltip ? VALUE_BUBBLE_ROOM : vertical ? 10 : 0 }}>
          <Slider
            className="af-slider-field"
            disabled={disabled || isLocked}
            dots={showDots}
            marks={marks}
            max={max}
            min={min}
            onChange={(value) => onChange(name, value)}
            step={step}
            value={toNumber(value)}
            activeDotStyle={activeDotStyle}
            dotStyle={dotStyle}
            handleStyle={handleStyle}
            railStyle={railStyle}
            trackStyle={trackStyle}
            handle={showTooltip ? renderHandleWithValue(min) : undefined}
          />
          {hasValue(value) && <input type="hidden" name={name} value={value} />}
        </div>
      </FieldContainer>
    );
  }
}

SliderField.defaultProps = {
  disabled: false,
  locked: false,
  max: 10,
  min: 0,
  showDots: true,
  showTooltip: true,
  step: 1,
  styles: {},
  vertical: undefined,
};

SliderField.propTypes = {
  disabled: PropTypes.bool,
  locked: PropTypes.bool,
  marks: PropTypes.object,
  max: PropTypes.number,
  min: PropTypes.number,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  showDots: PropTypes.bool,
  showTooltip: PropTypes.bool,
  step: PropTypes.number,
  styles: PropTypes.object,
  value: PropTypes.number.isRequired,
  vertical: PropTypes.bool,
};

export default SliderField;
